<template>
    <div :class="['conversation-area', { 'mobile-hidden': showContacts && isMobile }]">
        <template v-if="selectedContact">
            <!-- Header -->
            <ConversationHeader :contact="selectedContact" :is-mobile="isMobile" @back="$emit('back')" />


            <!-- Messages Feed & Composer only if available -->
            <template
                v-if="selectedContact.offer.offer_products.every(p => p.product.has_been_sold !== 1 && p.product.deleted_at === null)">
                <!-- Product Preview -->
                <div class="contact-product-card" ref="productCard">
                    <OfferBuyNowForm ref="OfferBuyNow" v-if="selectedContact"
                        :key="selectedContact.id + '-' + selectedContact.offer.id"
                        :products="selectedContact.offer.offer_products" :price="selectedContact.offer.price"
                        quantity="1" :nextPrice="selectedContact.offer.price" :selectedContact="selectedContact"
                        :messages="messages"
                        @product-loaded="(product) => $emit('contact-product-loaded', selectedContact, product)"
                        @show-offer-modal="$emit('show-offer-modal', $event)" />
                </div>
                <MessagesFeed ref="messagesFeed" :messages="messages" :user="user" :product=selectedContact.product
                    @respond-offer="$emit('respond-offer', $event.offerId, $event.response)"
                    @move-to-product="$emit('move-to-product', $event)" />
                <MessageComposer :message-input="messageInput" @update-input="$emit('update-message-input', $event)"
                    @send="$emit('send-message')" />
            </template>
            <template v-else>
                <!-- Product Preview (Disabled) -->
                <div class="contact-product-card disabled-overlay" ref="productCard">
                    <OfferBuyNowForm ref="OfferBuyNow" v-if="selectedContact"
                        :key="selectedContact.id + '-' + selectedContact.offer.id"
                        :products="selectedContact.offer.offer_products" :price="selectedContact.offer.price"
                        quantity="1" :nextPrice="selectedContact.offer.price" :selectedContact="selectedContact"
                        :messages="messages"
                        @product-loaded="(product) => $emit('contact-product-loaded', selectedContact, product)"
                        @show-offer-modal="$emit('show-offer-modal', $event)" />
                </div>
                <MessagesFeed class="disabled-overlay" ref="messagesFeed" :messages="messages" :user="user"
                    :product=selectedContact.product
                    @respond-offer="$emit('respond-offer', $event.offerId, $event.response)"
                    @move-to-product="$emit('move-to-product', $event)" />
                <div class="status-losing text-muted text-center py-2 mt-auto">{{ $t('sentence.notAvailable') }}</div>
            </template>
        </template>

        <div v-else class="no-conversation">
            <p>{{ $t('messenger.select-contact') }}</p>
        </div>
    </div>
</template>

<script>
import ConversationHeader from "@/components/messenger/ConversationHeader.vue";
import MessagesFeed from "@/components/messenger/MessagesFeed.vue";
import MessageComposer from "@/components/messenger/MessageComposer.vue";
import OfferBuyNowForm from "@/components/messenger/OfferBuyNowForm.vue";
import { gsapAnimations } from "@/services/gsapAnimations";

export default {
    name: "ConversationArea",
    components: {
        ConversationHeader,
        MessagesFeed,
        MessageComposer,
        OfferBuyNowForm
    },
    props: {
        selectedContact: {
            type: Object,
            default: null
        },
        messages: {
            type: Array,
            required: true
        },
        messageInput: {
            type: String,
            required: true
        },
        isMobile: {
            type: Boolean,
            required: true
        },
        showContacts: {
            type: Boolean,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    watch: {
        messages() {
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        selectedContact(newContact, oldContact) {
            // Animate when contact changes
            if (newContact&&newContact!==oldContact) {
                this.$nextTick(() => {
                    this.animatePageChange();
                });
            }
        }
    },
    mounted() {
        // Wait for DOM to be fully ready
        this.$nextTick(() => {
            this.animatePageChange();
        });
    },
    methods: {
        scrollToBottom() {
            if (this.$refs.messagesFeed) {
                this.$refs.messagesFeed.scrollToBottom();
            }
        },
        animatePageChange() {
            // Get the actual DOM element
            const element=this.$refs.productCard;
            if (element) {
                gsapAnimations.animatePageChange(element, {
                    direction: 'down',
                    duration: 0.6,
                    ease: 'power2.out'
                });
            }
        }
    }
};
</script>

<style scoped>
.conversation-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: white;
}

.contact-product-card {
    border-radius: 8px;
    overflow: hidden;
}

.contact-product-card>>>.container {
    max-width: 100%;
    padding: 0;
    margin: 0;
}

.contact-product-card>>>.form-bg {
    padding: 12px;
    background: rgb(241, 241, 255);
    border-radius: 8px;
    margin: 0;
}

.contact-product-card>>>.price-section {
    margin-bottom: 8px;
}

.contact-product-card>>>.price-number {
    font-size: 18px;
}

.contact-product-card>>>.quantity-section {
    display: none;
}

.contact-product-card>>>.action-buttons {
    margin-top: 12px;
    gap: 8px;
}


.no-conversation {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-500);
    font-size: 14px;
}

.disabled-overlay {
    position: relative;
    pointer-events: none;
    opacity: 0.9;
}

.disabled-overlay::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 1;
}

@media (max-width: 767px) {
    .conversation-area {
        width: 100%;
    }

    .mobile-hidden {
        display: none !important;
    }

    .contact-product-card>>>.btn {
        height: 40px;
        font-size: 12px;
        padding: 0 12px;
    }

}
</style>